import React, { useEffect, useMemo, useState } from "react";
import { useAuth } from "../../contexts/authContext";
import { useTranslation } from "react-i18next";
import { useLocation, useHistory } from "react-router-dom";

import { Button, Menu } from "antd";
import { IconLogout } from "../../components/icons";

import { SIDEBAR_PROFILE_V2 } from "../../constants/check";
import { deleteSession, formatRole } from "../../utils/common";

const ProfileSideBar = () => {
  const { t } = useTranslation(["common", "notification"]);
  const auth = useAuth();
  const history = useHistory();
  const location = useLocation();
  const [selectedKey, setSelectedKey] = useState<string>(location.pathname);

  const getDisplayName = () => {
    if (!auth || !auth.user) {
      return "";
    }
    if (auth.user.first_name && auth.user.last_name) {
      return auth.user.last_name + " " + auth.user.first_name;
    }
    if (auth.user.first_name && !auth.user.last_name) {
      return auth.user.first_name;
    }
    if (!auth.user.first_name && auth.user.last_name) {
      return auth.user.last_name;
    }
    return auth.user.phone || auth.user.email || "User";
  };

  const handleLogOut = () => {
    deleteSession();
    auth.logout();
    history.push("/login");
  };

  const filteredLinks = useMemo(() => {
    const result = SIDEBAR_PROFILE_V2.filter((item: any) => {
      return (
        !item?.role?.length || item?.role?.includes(auth.user?.business_role)
      );
    });
    return result;
  }, [auth.user?.business_role]);

  useEffect(() => {
    setSelectedKey(location.pathname);
  }, [location]);

  return (
    <div
      className="hidden lg:block h-fit shadow rounded-sm overflow-hidden shrink-0"
      style={{
        width: 285,
      }}
    >
      <div className="bg-white py-16">
        <div className="flex items-center pl-24">
          <div className="rounded-full overflow-hidden w-40 h-40 shrink-0">
            <img
              src="https://statics.vntrip.vn/images/default-avatar.png"
              className="object-cover h-full"
              alt={"Standardlogo"}
            />
          </div>
          <Button
            className="hover:border-none border-none w-full justify-start gap-16"
            style={{ boxShadow: "unset" }}
          >
            <div className="flex flex-col items-start">
              <span className="font-semibold text-black-1  mb-4">
                {getDisplayName()}
              </span>
              <span className="text-red-primary text-sm font-semibold">
                {t(formatRole(auth?.user?.business_role))}
              </span>
            </div>
          </Button>
        </div>
      </div>
      <div className="h-0.5 px-16 bg-grey-3"></div>

      <Menu mode="inline" selectedKeys={[selectedKey]}>
        {filteredLinks.map((item: any) => {
          if (Array.isArray(item?.children) && item?.children.length > 0) {
            return (
              <Menu.SubMenu
                className="transition-none !pl-0"
                key={item.key}
                icon={item.icon()}
                title={<span className="text-md">{t(item.label)}</span>}
              >
                {item.children.map((child: any) => {
                  return (
                    <Menu.Item key={child.key} className="">
                      <a href={child.path}>
                        <span className="text-md">
                          {t(`common:${child.label}`)}
                        </span>
                      </a>
                    </Menu.Item>
                  );
                })}
              </Menu.SubMenu>
            );
          }

          return (
            <>
              <Menu.Item
                key={item.key}
                icon={item.icon()}
                className="flex items-center gap-16 transition-none !pl-16"
              >
                <a href={item.path}>
                  <span className="text-md">{t(item.label)}</span>
                </a>
              </Menu.Item>
            </>
          );
        })}
      </Menu>

      <div className="bg-white py-8 border-t border-grey-3 border-solid">
        <Button
          className="ml-4 pl-16 hover:border-none border-none w-full h-40 justify-start gap-16 shadow-none"
          onClick={handleLogOut}
        >
          <IconLogout />
          <span className="text-black-1 text-md">{t("Đăng xuất")}</span>
        </Button>
      </div>
    </div>
  );
};

export default ProfileSideBar;
